module.exports = __webpack_public_path__ + "assets/agda-4e20f6cfb1fe5e3ae77e78124d4ff5bd.svg";